export const environment = {
  production: true,
  apiUrl: 'https://carbon.api.ticcbox.com/api/',
  allowedDomain: 'carbon.api.ticcbox.com',
  // Feature flag: render Mains/Solar PV with the native Angular chart instead of the SSRS iframe.
  // Off by default so the existing report stays the fallback until the native one is signed off.
  nativeResourceChart: true,
  powerbiUrl: 'https://app.powerbi.com/reportEmbed?reportId=89509c01-c965-4c7f-bdf5-ba956ea61205&autoAuth=true&ctid=0ecaafc0-26d5-4615-8726-9a11627b2796'
};
